import { Box, HStack, Icon, Text, Progress, SimpleGrid } from '@chakra-ui/react';
import { FiUsers, FiCheck, FiTrendingUp, FiCalendar } from 'react-icons/fi'
import type { CampaignStatsDto } from '../../../types/campaign'

interface Props {
  stats: CampaignStatsDto | undefined
  createdAt: string
}

function daysSince(dateStr: string): number {
  const created = new Date(dateStr)
  const now = new Date()
  return Math.max(1, Math.floor((now.getTime() - created.getTime()) / (1000 * 60 * 60 * 24)))
}

export function CampaignLifetimeStats({ stats, createdAt }: Props) {
  const days = daysSince(createdAt)

  return (
    <SimpleGrid columns={{ base: 2, md: 4 }} gap={4}>
      <StatItem
        icon={FiUsers}
        label="Universe"
        value={stats?.totalContacts.toLocaleString() ?? '—'}
      />
      <StatItem
        icon={FiCheck}
        label="Contacted"
        value={stats?.visitedContacts.toLocaleString() ?? '—'}
      />
      <Box>
        <HStack gap={2} color="gray.500" mb={1}>
          <Icon boxSize={3} asChild><FiTrendingUp /></Icon>
          <Text fontSize="xs" fontWeight="medium" textTransform="uppercase">Completion</Text>
        </HStack>
        <HStack gap={2}>
          <Text fontWeight="bold" fontSize="lg">{stats?.completionPercent ?? 0}%</Text>
          <Progress.Root
            value={stats?.completionPercent ?? 0}
            size="sm"
            colorPalette="green"
            borderRadius="full"
            flex={1}
            maxW="80px">
            <Progress.Track>
              <Progress.Range />
            </Progress.Track>
          </Progress.Root>
        </HStack>
      </Box>
      <StatItem
        icon={FiCalendar}
        label="Days Active"
        value={String(days)}
      />
    </SimpleGrid>
  );
}

function StatItem({ icon, label, value }: { icon: React.ElementType; label: string; value: string }) {
  return (
    <Box>
      <HStack gap={2} color="gray.500" mb={1}>
        <Icon as={icon} boxSize={3} />
        <Text fontSize="xs" fontWeight="medium" textTransform="uppercase">{label}</Text>
      </HStack>
      <Text fontWeight="bold" fontSize="lg">{value}</Text>
    </Box>
  );
}
